/* eslint-disable max-lines -- generated translation artifact */
import type { TranslationKeyMap } from "../types";

export const I18N_TRANSLATION_KEYS = {
  common: {
    "Download for Android": {
      hash: "08f13c0eaa454ceb",
    },
    "Download for iOS": {
      hash: "7707b94233940ee1",
    },
    "Download the Clipboard Workplace app to view your schedule, post shifts, and message your workers on the go.":
      {
        hash: "2074af6eeb2b3275",
      },
    "Error Loading Notifications. Please try again later.": {
      hash: "926cc946fedafbf5",
    },
    "No current notifications": {
      hash: "51ade6c018ded413",
    },
    Notifications: {
      hash: "788011833a5a0f22",
    },
    "Take Clipboard with you": {
      hash: "efd29d8c54d0a8ff",
    },
  },
  navigation: {
    Accounts: {
      hash: "8a7c8b67fe8bde8b",
    },
    "Admin Tools": {
      hash: "af0c3ba6a2ca80ba",
    },
    Analytics: {
      hash: "94c116ee118a7299",
    },
    "Application & Jobs": {
      hash: "d159134ea385fdbc",
    },
    "Are you sure you want to log out?": {
      hash: "8378c006e5505ccf",
    },
    Availability: {
      hash: "12f67f8539c46701",
    },
    "Badge Verification Grading": {
      hash: "92b899d39a9f6e5c",
    },
    Bans: {
      hash: "4d5469c7be3b5130",
    },
    Billing: {
      hash: "3ac8bbca9a74cfbd",
    },
    "Browse Professionals": {
      hash: "d9e7915f59343c9b",
    },
    "Browse Talent Pool": {
      hash: "f5b152d912d4a37a",
    },
    "By Number": {
      hash: "bcc957ee4ec02126",
    },
    "By Period": {
      hash: "189d145aadfed8e7",
    },
    Calendar: {
      hash: "d5d0a30b517e3bea",
    },
    "Calendar (Classic)": {
      hash: "edad27774d43f2d1",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Candidate Profile": {
      hash: "96d96be238230962",
    },
    Cases: {
      hash: "2249bd503ec47d72",
    },
    "Change Log": {
      hash: "6fd553132e7785dc",
    },
    Charting: {
      hash: "f4d573798f5b25fe",
    },
    Chat: {
      hash: "460b3a7da007b7af",
    },
    "Clipboard Score": {
      hash: "5a639e298037569b",
    },
    "Confirm Log Out": {
      hash: "46d51ff0db7eb2e9",
    },
    "Contract Terms": {
      hash: "be5acd2ec9bc6849",
    },
    "Copied!": {
      hash: "ea61bc15688d1e48",
    },
    "Copy details": {
      hash: "ec7ee2826c849564",
    },
    "Corporate Analytics": {
      hash: "8adad8a24dbd0f7b",
    },
    "Corporate Center": {
      hash: "daeb3a9c6c097148",
    },
    "Coverage Map": {
      hash: "ac9cde5b5bee03f3",
    },
    "Currently Viewed": {
      hash: "9839593ad1155065",
    },
    DNR: {
      hash: "9ca1816c47234807",
    },
    DNRs: {
      hash: "f6120e8981f1882f",
    },
    Eligibility: {
      hash: "dfa9dfa5cad2d8f9",
    },
    Employees: {
      hash: "c98270317b51cbb3",
    },
    Exclusions: {
      hash: "fcc9f1f929785440",
    },
    "External Photos": {
      hash: "ee1b6e3886b4d185",
    },
    "Getting started": {
      hash: "831d0f72d242b7d1",
    },
    "Help Center": {
      hash: "a78cebc44214256b",
    },
    Hiring: {
      hash: "4e414af41b7d4876",
    },
    "Home Health Worker Search": {
      hash: "ff9c41ba1c875fb1",
    },
    "Interview Availability": {
      hash: "c2c3b55d9c20c18a",
    },
    "Interview Schedule": {
      hash: "3fa7a764f8ffaa77",
    },
    Interviews: {
      hash: "0b9e49cf035bd75b",
    },
    Invoice: {
      hash: "b832002da297545f",
    },
    "Invoice History": {
      hash: "8f74e5015dd26f64",
    },
    "Landing Page": {
      hash: "a93cb7c71ee33577",
    },
    "Live Worker ETA": {
      hash: "4e952b41752d7990",
    },
    Locations: {
      hash: "95c61170318a2851",
    },
    "Log Out": {
      hash: "d57d48b71020b33a",
    },
    "Logging out…": {
      hash: "5a79edda3e34d40e",
    },
    Management: {
      hash: "e51248773b9a3f59",
    },
    "My Account": {
      hash: "ad0187add790ff17",
    },
    "My Internal Roster": {
      hash: "30a2860742589675",
    },
    "My Professionals": {
      hash: "708e415f9ac11beb",
    },
    "No Shows": {
      hash: "9474c5cf93f62e30",
    },
    Payroll: {
      hash: "53fe8dfb6d9e1b03",
    },
    "Permanent Hiring": {
      hash: "65287dcca549e0db",
    },
    Placement: {
      hash: "4df9939944a7b324",
    },
    "Post-Invoice Disputes": {
      hash: "363d6a41a48b73a6",
    },
    "Pre-Invoice Disputes": {
      hash: "e3373cf04f80ef64",
    },
    "Professional ID": {
      hash: "38f01b3c5ffc13e3",
    },
    "Professional Name": {
      hash: "99f2b26bd7057b5b",
    },
    Professionals: {
      hash: "c8d715a6f56bac25",
    },
    Qualifications: {
      hash: "7b4339cf860e01a6",
    },
    "Recently Viewed": {
      hash: "eab19ec694a80bca",
    },
    "Recently Viewed Accounts": {
      hash: "37ae24bdf1c25cd2",
    },
    "Refer & Earn": {
      hash: "6b653f745fa52b81",
    },
    Reporting: {
      hash: "b1fa104b9bf0635e",
    },
    Requirements: {
      hash: "e0cdd07f6a270b82",
    },
    Reviews: {
      hash: "84cb7871b741c32e",
    },
    "Reviews Moderation": {
      hash: "47484938c8a87102",
    },
    "SMS Portal": {
      hash: "c7677b97318f448a",
    },
    "SSN Worker Lookup": {
      hash: "55542efef9055f03",
    },
    Schedule: {
      hash: "f4830a1dae298044",
    },
    Scraping: {
      hash: "cf38d8fe149ecdf8",
    },
    Settings: {
      hash: "74a883a037bc227f",
    },
    "Shift Explainer": {
      hash: "372330d1b42e8de2",
    },
    "Shift Logs": {
      hash: "5c7b8d053d5b3e26",
    },
    "Shift Payments": {
      hash: "fa00fd7d75c43f54",
    },
    "Shift Search": {
      hash: "83f74582a922da01",
    },
    Shifts: {
      hash: "3c653dabeef2e3c2",
    },
    "Shifts Verification": {
      hash: "7a21f9b68442b295",
    },
    "Spend Controls": {
      hash: "9a03073fb5cf415d",
    },
    Staffing: {
      hash: "0e199ed6d6f4b783",
    },
    "Stripe Payouts": {
      hash: "db87f5ee3afa1ca9",
    },
    "Stripe Transfers": {
      hash: "85279245c3c16c92",
    },
    "Tap to copy": {
      hash: "abefee79c9ed4bb3",
    },
    "Team Members": {
      hash: "e2204b3eaff613de",
    },
    "Timeclock Requests": {
      hash: "f2b4bd6f9b506e10",
    },
    "Timeclocking Settings": {
      hash: "881a371729ce67f0",
    },
    "Timekeeping Videos": {
      hash: "5e39688b3981234f",
    },
    "Under construction": {
      hash: "ac549c250b476176",
    },
    "Upcoming Charges": {
      hash: "a2fb237d15320535",
    },
    "View More": {
      hash: "15435b311c937143",
    },
    "Visit Verification": {
      hash: "c897635c22a67087",
    },
    "We're currently making improvements to our mobile app. When it's ready, we'll let you know!": {
      hash: "fe01dd4acbf69e7c",
    },
    "Worker Evidences": {
      hash: "8c13bf02a1a2b30e",
    },
    Workers: {
      hash: "7a1ec9fe6c3b483f",
    },
    "Workplace Analytics": {
      hash: "63256883cad9b1a5",
    },
    "Workplace ID": {
      hash: "049245ad1f768a37",
    },
    "Workplace Information": {
      hash: "b1d3c3c3f44d8a16",
    },
    "Workplace Name": {
      hash: "216f411031cbef73",
    },
    "Workplace Requirements": {
      hash: "904b4af203bd9342",
    },
    "Workplace Rules Quiz": {
      hash: "e3c8c9b2fc87dc21",
    },
    "Workplace Types": {
      hash: "10104f72c61f60fd",
    },
    Workplaces: {
      hash: "324ddac12d893a7d",
    },
    "You will need to sign in again to access your account.": {
      hash: "26d6fb4222835ff1",
    },
  },
  schedule: {
    "(add)": {
      hash: "0759437ec2b49a2f",
    },
    "(remove)": {
      hash: "d64bad115a57a139",
    },
    ". If not, please forward this link to the person at your organization who should sign.": {
      hash: "3151c8d8f3418084",
    },
    "72 hours post suspension": {
      hash: "64b66898bb10ed0e",
    },
    "Account pending": {
      hash: "3d1b86d01a167687",
    },
    "Account suspended": {
      hash: "cb35a570b6e4baa6",
    },
    "Account suspended for missing payments": {
      hash: "e9140d190970aa34",
    },
    "Account usage temporarily paused": {
      hash: "3169d6942414f3b0",
    },
    "Acknowledge the late cancellation fee to proceed": {
      hash: "21821f4dd188bf0b",
    },
    "Action Needed: Your contract requires a signature to avoid service interruptions.": {
      hash: "18b5c627fdd66dff",
    },
    "Action needed: please ensure your contract details are up-to-date by {{deadline}}": {
      hash: "30c80016cf2cca67",
    },
    "Add any additional information that you want to share with the professional about this block.":
      {
        hash: "32f665851af6351c",
      },
    "Add information": {
      hash: "06c578f913653c48",
    },
    "Add multiple shifts": {
      hash: "9db29e4b9988dc6f",
    },
    "Add one {{slotLabel}} shift on {{dateLabel}}": {
      hash: "9f48f1c96fafcc8a",
    },
    "Add or remove at least one shift before submitting": {
      hash: "5aa786bd3cbe7854",
    },
    "Add shift": {
      hash: "bfcd93723edb6e2e",
    },
    "Add shifts mode": {
      hash: "10b724964a717d29",
    },
    "Add {{slotLabel}} shift": {
      hash: "d08a6f77815f3a67",
    },
    "Add {{slotLabel}} shift to block": {
      hash: "f929f2c4c375f54e",
    },
    "Add {{workerName}} to Do Not Return list": {
      hash: "d97968b23b2ee87b",
    },
    "Adding {{qualificationLabel}} shifts": {
      hash: "83a03d5fe0e91d5a",
    },
    All: {
      hash: "a52ace420f2175d0",
    },
    "All future shifts after {{suspensionDate}} are canceled and you can't post any new shifts. Please contact support for assistance.":
      {
        hash: "231d5ad2f40c41b6",
      },
    "All shifts": {
      hash: "95e445f6311803b9",
    },
    "All shifts after {{suspensionDate}} are canceled, and new shifts can't be posted. Please submit a payment or contact us at billing@clipboardhealth.com for assistance.":
      {
        hash: "d6f0922393cee1c1",
      },
    "All upcoming shifts for the shift block have been cancelled": {
      hash: "fd34be170e1eabc0",
    },
    "All upcoming shifts for the shift block have been removed": {
      hash: "94db8329fecc5718",
    },
    "All {{totalShifts}} filled": {
      hash: "82d1af9a1ba4f3ad",
    },
    "Any qualified professional can book": {
      hash: "8bb5c11f9e2c57a9",
    },
    "Applying changes": {
      hash: "3a962c2d16deec6e",
    },
    "Are you sure you want to cancel this {{shiftCount}}-shift block from {{dateRange}}?": {
      hash: "7bb59e6f16e56dda",
    },
    "Are you sure you want to remove this {{shiftCount}}-shift block from {{dateRange}}?": {
      hash: "aa4341053cc3c078",
    },
    "Ask an admin or corporate decision maker to enable Variable Charge for your workplace.": {
      hash: "1bf94bc3f4fcb496",
    },
    "Ask your facility admin to add or remove professional types": {
      hash: "553a4a75b246d634",
    },
    "Available Professionals": {
      hash: "0d8cc6461b0c6858",
    },
    Block: {
      hash: "211d0bb8cf4f5b52",
    },
    "Block ID:": {
      hash: "6f92dd1d3de72e35",
    },
    "Block posting": {
      hash: "6952ce3ec3574335",
    },
    "Book one worker for consecutive days as an all-or-nothing block.": {
      hash: "4a0df895879bfb77",
    },
    Bulk: {
      hash: "3140100df131cf30",
    },
    "Bulk posting": {
      hash: "35acb87b3b3529db",
    },
    "Bulk posting complete": {
      hash: "f8e47f10d5dc8923",
    },
    "Bulk posting failed": {
      hash: "cfa969c682dfd6e6",
    },
    "Calendar & Filters": {
      hash: "dcacb8cfa6feed47",
    },
    "Calendar view mode": {
      hash: "524509f2506a2d08",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Cancel block": {
      hash: "119a718f0a036cbe",
    },
    "Cancel block?": {
      hash: "648ee100798ed22c",
    },
    "Canceled shift": {
      hash: "30f7b875a0165505",
    },
    "Canceled shift ($)": {
      hash: "e6f4e5011fc9f121",
    },
    Chat: {
      hash: "460b3a7da007b7af",
    },
    "Clear all": {
      hash: "29a390f9237e3c84",
    },
    "Clear {{slotLabel}} shifts on {{dateLabel}}": {
      hash: "5e1518bc8f5b7460",
    },
    "Click a calendar slot to stage a shift in this block. You need at least two to post.": {
      hash: "55b6b511e5c3158e",
    },
    "Clocked in {{time}}": {
      hash: "6c7b0e7ddfb18671",
    },
    "Clocked out {{time}}": {
      hash: "bbb0da2768b15762",
    },
    Close: {
      hash: "7d9eb7acb13e2462",
    },
    "Close add shifts": {
      hash: "450538c1602e67c7",
    },
    "Close day panel": {
      hash: "7229bffa105473fa",
    },
    "Close shift block details": {
      hash: "c6a473c0b60eab88",
    },
    "Close sidebar": {
      hash: "17e28e2302175d33",
    },
    "Configure block": {
      hash: "fb3976bbbd316226",
    },
    "Contact Clipboard": {
      hash: "5a365d43779e1354",
    },
    "Contact support": {
      hash: "814f4ed2d5bd33e3",
    },
    Continue: {
      hash: "31fbef162594de01",
    },
    "Could not cancel the shift block. Please try again.": {
      hash: "c460db5e7ffae1dc",
    },
    "Could not load shift block details.": {
      hash: "d3074e49b63e8eea",
    },
    "Could not remove the shift block. Please try again.": {
      hash: "604bb026660c00eb",
    },
    "Create a block of shifts": {
      hash: "3c9d9544c83915b4",
    },
    "Currently required before booking": {
      hash: "25a665e3b1181d73",
    },
    Day: {
      hash: "8f2364e11b8be3ff",
    },
    "Declined invite": {
      hash: "8ad5acfe0b6db645",
    },
    "Dismiss available workers panel": {
      hash: "f26e99281ea8898f",
    },
    "Dismiss banner": {
      hash: "ea8c089e16a3de62",
    },
    "Do Not Return": {
      hash: "f4b4637b4395a437",
    },
    "Do you want to proceed with posting {{subject}}?": {
      hash: "c8c1b56f18d10c2d",
    },
    "Document requirements": {
      hash: "050eb4ea88bb108f",
    },
    Done: {
      hash: "11a6767d5674c7e4",
    },
    Draft: {
      hash: "ebf12ef47cf575b3",
    },
    Edit: {
      hash: "464c4ffd019e1e96",
    },
    "Edit time": {
      hash: "59ebe97eedd6795e",
    },
    "Edit {{qualification}} shift times": {
      hash: "d7ac4069df5d4780",
    },
    "Edit {{slotLabel}} shift times - {{dayLabel}}": {
      hash: "0f7a05f2d2b6420f",
    },
    "Edit {{slotLabel}} shift times on {{dateLabel}}": {
      hash: "9bee0cca8c8afc57",
    },
    "Edit {{slotLabel}} shift times on {{dateLabel}} (custom)": {
      hash: "dd290a557b7edd34",
    },
    "Enable Variable Charge to encourage healthcare professionals to book shifts during {{eventName}}. Once enabled, you can edit rates directly from shift actions.":
      {
        hash: "40b70bd43b31ecbb",
      },
    "Enable Variable Charge to help fill shifts during {{eventName}}. You can edit rates directly from shift actions.":
      {
        hash: "a55076cebaa7f342",
      },
    "Enable block booking": {
      hash: "77df31107c9cd6a2",
    },
    "Enable instant book": {
      hash: "832c49d5487a2b06",
    },
    "Enable priority access": {
      hash: "ce48147aa61ee906",
    },
    "Exit block posting": {
      hash: "2f5354e56825ae7f",
    },
    "Exit bulk posting": {
      hash: "17c8d95161a70ad9",
    },
    "Expected {{time}}": {
      hash: "439c9e0014d79dcb",
    },
    "Expired invite": {
      hash: "545aeab0cb25f867",
    },
    "Failed to add professional to the Do-Not-Return list.": {
      hash: "3778a9b61578a0d5",
    },
    "Failed to create block": {
      hash: "802ab5569606ed0d",
    },
    "Failed to create shifts": {
      hash: "e1cd25b85547bd46",
    },
    "Failed to load shifts. Please try again.": {
      hash: "e46f0ad78f6d48fa",
    },
    "Failed to update shift times": {
      hash: "69774c6c1c99615a",
    },
    "Fill Guarantee applied": {
      hash: "89bf5c6461335cb0",
    },
    "Fill shifts faster by making document requirements optional": {
      hash: "56885bbb2cfcb446",
    },
    "Filter shift types": {
      hash: "102942783e52049d",
    },
    "Finding a replacement...": {
      hash: "2f3ad8a786e16944",
    },
    "Finish signing up": {
      hash: "7d0bd0942884cd45",
    },
    Fr: {
      hash: "eed8f901692d0856",
    },
    "Go to today": {
      hash: "75d83f7682f56a52",
    },
    "Helpful information for professional (optional)": {
      hash: "b96a6050465ef6df",
    },
    "Hide sidebar": {
      hash: "d1db29ebc76d9f61",
    },
    "If you're authorized to sign this contract, please do so": {
      hash: "f42dfa382dc36c83",
    },
    "Important!": {
      hash: "055881ac6763cba0",
    },
    "Invite sent": {
      hash: "b40a57c0c9b17557",
    },
    "Keep block": {
      hash: "e11f44d32d49dfd2",
    },
    "Loading shifts...": {
      hash: "897a71d5318d675b",
    },
    "Maintain Coverage During Memorial Day Weekend": {
      hash: "ca473770db3a6529",
    },
    "Maintain Coverage During the Winter Storm": {
      hash: "159c9a4771cb8656",
    },
    "Make document requirements optional": {
      hash: "f23e6c26374bbc50",
    },
    "Memorial Day Weekend": {
      hash: "a4516904313c6ff4",
    },
    "Memorial Day Weekend Coverage": {
      hash: "646662c9cc44caf4",
    },
    Mo: {
      hash: "d23e867e38e89ebf",
    },
    Month: {
      hash: "310ca503ef36f177",
    },
    "Next date": {
      hash: "259f577df539d7cd",
    },
    "Next month": {
      hash: "74e53211fef4b4d4",
    },
    "No available professionals found.": {
      hash: "f731562ef07f6f72",
    },
    "No professional types are included in your contract yet. Please contact support to update your contract.":
      {
        hash: "d6df29adae3ef050",
      },
    "No shifts added yet": {
      hash: "17303837a7538dd9",
    },
    "No shifts on this day": {
      hash: "96b562d99d00fdab",
    },
    "No shifts scheduled": {
      hash: "0e113a777f41b3a5",
    },
    "No shifts staged yet": {
      hash: "675781c7c0e04437",
    },
    "No {{timeSlot}} shifts were posted": {
      hash: "cb86a681fcfaf0da",
    },
    "Not now": {
      hash: "a0e63d7c7125d29a",
    },
    "Notes for professionals": {
      hash: "7038572cdeb56103",
    },
    Notice: {
      hash: "65659145569b894b",
    },
    "One professional books an entire block": {
      hash: "9cd196d90bf55de2",
    },
    Only: {
      hash: "879d8fb64f88733e",
    },
    "Open daily view for {{dateLabel}}": {
      hash: "3095ee946570a186",
    },
    "Open {{dateLabel}} shifts": {
      hash: "fd11f315e1f2cf34",
    },
    Optional: {
      hash: "59be71333c960fd0",
    },
    "Optional — tell the professional anything they should know.": {
      hash: "cdcf0c647f9af9c6",
    },
    "Or select a calendar slot to add a shift": {
      hash: "1aa7434e840e2e6f",
    },
    "Part of a {{shiftCount}}-shift block": {
      hash: "28fa073686270307",
    },
    "Payment due": {
      hash: "a648708bed4aa733",
    },
    "Pending rate proposals": {
      hash: "8d8c27652b244dfe",
    },
    "Pending requests to book": {
      hash: "8b045ff0baac5c19",
    },
    "Please ensure your contract details are up-to-date by {{deadline}}. If you have any questions, please reach out to":
      {
        hash: "ed77e681ad80e655",
      },
    "Please review and sign your": {
      hash: "255381b98af5d088",
    },
    "Post a new {{qualificationDisplayName}} shift": {
      hash: "24331847f1d79bdf",
    },
    "Post a new {{timeSlot}} shift": {
      hash: "7ed1f0d4b2b0faeb",
    },
    "Post block": {
      hash: "0148bffc150339a2",
    },
    "Post shifts": {
      hash: "d3159e27a9330927",
    },
    "Post shifts with rush fee": {
      hash: "7e95d39fd43fb729",
    },
    "Post {{additionTotal}} & Remove {{removalTotal}}": {
      hash: "36b67fc35f565beb",
    },
    "Post {{additionTotal}} shifts": {
      hash: "bfb925ed2f8e4326",
    },
    "Preparing removals...": {
      hash: "02aa21b190be93e3",
    },
    "Previous date": {
      hash: "df2d0dc8e24c0ff3",
    },
    "Previous month": {
      hash: "6a2769502a5dda78",
    },
    "Professional type": {
      hash: "3617bd6b5a419818",
    },
    "Professional types info": {
      hash: "127c043502a4a52d",
    },
    "Professionals can book without this document": {
      hash: "6ba7ed94943d0b33",
    },
    Profile: {
      hash: "d696a35bdd1883da",
    },
    "Provide additional information about your workplace to get higher chances to fill your shifts.":
      {
        hash: "43e2e6af44325a1b",
      },
    "Rather discuss your required documents?": {
      hash: "7450add02db5e174",
    },
    Refresh: {
      hash: "0e91610117029a62",
    },
    "Remove block": {
      hash: "50789882cb44cfc0",
    },
    "Remove block?": {
      hash: "b48fd06fbc1b8006",
    },
    "Remove one {{slotLabel}} shift on {{dateLabel}}": {
      hash: "7af129ac87e6c3fb",
    },
    "Remove {{removalTotal}} shifts": {
      hash: "010926c3ad6a439e",
    },
    "Remove {{slotLabel}} shift": {
      hash: "a0dcca719b0b6692",
    },
    "Remove {{slotLabel}} shift from block": {
      hash: "9ec09d9fdf3dd405",
    },
    "Remove {{slotLabel}} shift on {{dateLabel}} from block": {
      hash: "bd59825da9bf173a",
    },
    "Removing shifts... ({{removed}}/{{totalToRemove}})": {
      hash: "3e5616600c45579f",
    },
    Required: {
      hash: "4850b174b713d88c",
    },
    "Reset to default": {
      hash: "bc5b45ae7b60692a",
    },
    Retry: {
      hash: "942087cc2d41e013",
    },
    "Review and sign our contract so that you can start posting shifts.": {
      hash: "260eae735d6581d7",
    },
    "Review changes": {
      hash: "6a47708f4e14c122",
    },
    "Review requirements": {
      hash: "558904acdc18ee4e",
    },
    "Review the queued changes before applying them.": {
      hash: "dd999b9a72aa9249",
    },
    "Rush fee": {
      hash: "7d1e234cd60235a4",
    },
    Sa: {
      hash: "a951efc79deb7ff3",
    },
    Save: {
      hash: "1509f561f2416598",
    },
    "Save times": {
      hash: "df615262aa1a1669",
    },
    Saved: {
      hash: "b5c120b316c237a0",
    },
    "See less": {
      hash: "d1cee48d0de28c45",
    },
    "See more": {
      hash: "bab37d62472990c0",
    },
    "Select qualification": {
      hash: "a87abb24997dcec6",
    },
    "Select shift dates for your block": {
      hash: "1de82c89364987c9",
    },
    "Select {{date}}": {
      hash: "ea2cc40d45cd99cf",
    },
    "Select {{date}}, today": {
      hash: "9a7b8a4e1d434df4",
    },
    Send: {
      hash: "f6f4688ff23d50c6",
    },
    "Sent home at {{time}}": {
      hash: "f491d58207eb7fcb",
    },
    "Shift Block": {
      hash: "6269e24f31555003",
    },
    "Shift Types": {
      hash: "fbbf67422e5e3648",
    },
    "Shift times updated": {
      hash: "4161e0b718d06dfc",
    },
    "Shifts in block": {
      hash: "5bbd271ed5b84a80",
    },
    "Shifts in this block": {
      hash: "eb365f0fe1e6acbb",
    },
    "Shifts posted but quiz update failed": {
      hash: "d91ef4ac7730f4e3",
    },
    "Show all shift types": {
      hash: "ec6ef45d6169b644",
    },
    "Show fewer shift types": {
      hash: "95836f82062da8db",
    },
    "Show more shift types": {
      hash: "7e16ac00450dfbef",
    },
    "Show only {{label}}": {
      hash: "31eaff37b666d873",
    },
    "Show sidebar": {
      hash: "9e8197ce9e5f9592",
    },
    "Slot type": {
      hash: "2f3a0951c5962882",
    },
    "Some queued shifts are in the past.": {
      hash: "24b7bdf3f774ecd8",
    },
    "Some shifts start soon": {
      hash: "c2ff8acd4ad3c7b4",
    },
    "Someone from the Clipboard team will reach out within 1 business day to review your workplace's document requirements with you.":
      {
        hash: "cff929e95dd0ab8f",
      },
    "Start over": {
      hash: "5eed7e9fc8f3cd68",
    },
    Su: {
      hash: "2d88a3a2842eb3c9",
    },
    "Submit payment": {
      hash: "076957bce71fa868",
    },
    "Talk to someone from our team.": {
      hash: "a9e590a172099aac",
    },
    "Tap + to post a shift": {
      hash: "cc93c1c99d40314f",
    },
    Th: {
      hash: "3bff939c10f4d9bc",
    },
    "The Missed Punch Request feature is live for this workplace. Please follow the MPR SOP for any shift verification or adjustment requests.":
      {
        hash: "def235b01a680a58",
      },
    "The block has been created successfully": {
      hash: "b96d5ff6260b4c81",
    },
    "The professional has been added to the Do-Not-Return list.": {
      hash: "fb75f6d7a6206272",
    },
    "These documents are blocking nearby professionals who may be interested in your shifts.": {
      hash: "3ec90c0349b2f97b",
    },
    "These documents may be blocking nearby professionals from booking your shifts.": {
      hash: "3ce2791bc098fe1f",
    },
    "These times apply to every shift staged for this {{slotLabel}} slot on {{dayLabel}}. Other days use the workplace default.":
      {
        hash: "9ec49dbdc7bdcabf",
      },
    "These times become the default for {{qualification}} in month bulk posting and the daily posting surface.":
      {
        hash: "2d1f9e0d071255c9",
      },
    "This page has been updated while you were away. Refresh to get the latest.": {
      hash: "fcea6d759b6c1834",
    },
    Today: {
      hash: "2b065c7c9ce466e5",
    },
    "Toggle any requirement to optional and we'll update your workplace's document requirements.": {
      hash: "5c78570dfc24ed1f",
    },
    "Total new shifts:": {
      hash: "4774eebd95c6b9a8",
    },
    "Total shifts: {{shiftCount}}": {
      hash: "ee36016ce41c648c",
    },
    Tu: {
      hash: "62afcc74654de6ab",
    },
    "Type a message": {
      hash: "00cd58f655daed8a",
    },
    "Unable to load monthly counts.": {
      hash: "ceebd437e1769f44",
    },
    "Unable to load slot details.": {
      hash: "a597b36badcfaf6a",
    },
    Unfilled: {
      hash: "ca4153b6bb219647",
    },
    "Use the + button on a calendar slot to add shifts. They'll show up here grouped by day.": {
      hash: "8fbb370cbd171142",
    },
    "Variable Charge disabled": {
      hash: "1adcf08dfb9aae9e",
    },
    "Variable Charge enabled": {
      hash: "f667a06d7d7ff1b8",
    },
    "Variable Charge feature disabled.": {
      hash: "19aafeafb4adfec9",
    },
    "Variable Charge feature enabled. You can now edit rates on shift cards.": {
      hash: "b52874990d85754c",
    },
    "View candidates": {
      hash: "1060c7e27852f3f2",
    },
    "View contract": {
      hash: "964b67c944a13ef9",
    },
    "View {{shiftCount}}-shift block details": {
      hash: "aa3e775302e19635",
    },
    We: {
      hash: "f3fe997b8d1ce818",
    },
    "We want to help you maintain coverage during {{eventName}}. Ask an admin or corporate decision maker to enable Variable Charge for your workplace.":
      {
        hash: "ea62f7ad88138eed",
      },
    "We've identified a change of ownership for this facility and a new contract is required to continue using our platform. You're unable to book new shifts until the updated contract is in place.":
      {
        hash: "e4b6399c711b5c9b",
      },
    "Winter Storm Coverage": {
      hash: "204c32396d64a8af",
    },
    "You are about to post {{additionTotal}} and remove {{removalTotal}} {{qualificationLabel}} shifts.":
      {
        hash: "9872a19ccc59e398",
      },
    "You are about to post {{additionTotal}} {{qualificationLabel}} shifts.": {
      hash: "2e218ce6e44faf2c",
    },
    "You are about to remove {{removalTotal}} {{qualificationLabel}} shifts.": {
      hash: "74fd12fee729a47d",
    },
    "You are seeing this banner because key details in your contract need to be verified. To avoid interruption, please discuss this with our team by {{deadline}}.":
      {
        hash: "3524eba34999f164",
      },
    "You can only create a maximum of {{maximumShiftCount}} shifts at a time.": {
      hash: "b1b5289afe723700",
    },
    "You have": {
      hash: "af3f12e161fdb1cb",
    },
    "You have past due invoices. If you do not submit a payment by {{pendingDate}}, your account will be blocked from filling any further shifts. Any shifts that are already filled will not be affected.":
      {
        hash: "a411cdc69171bcef",
      },
    "You have unposted shifts": {
      hash: "df2c3b3e38746905",
    },
    "You've reached your weekly approved cap and are not able to post any further shifts. Please reach out to your account manager, billing representative, or billing@clipboardhealth.com for assistance.":
      {
        hash: "4796d436b7eec305",
      },
    "Your account is Pending due to past due invoices. Pending accounts cannot fill any further shifts, but shifts that are already filled will not be affected.":
      {
        hash: "2a817149e3aeea86",
      },
    "Your account is currently pending": {
      hash: "5ae266fd755ca628",
    },
    "Your account is inactive": {
      hash: "d900a0ee4fa75a07",
    },
    "Your account is inactive. Please reach out to Clipboard Health Support": {
      hash: "f67a23ce7574418d",
    },
    "Your account is pending": {
      hash: "38a99ec1b1d35732",
    },
    "Your account is suspended": {
      hash: "355a68d4614fc7f9",
    },
    "Your account is suspended for missing payments": {
      hash: "e51258e58c381769",
    },
    "Your account will be placed on hold due to missed payments": {
      hash: "92f5e0bdde0f12fb",
    },
    "Your usage cap has been reached": {
      hash: "bba4c17d03c1f365",
    },
    agreement: {
      hash: "46a81739c6ee7c1d",
    },
    "contact support online": {
      hash: "8795fb4cfe8a7f38",
    },
    "for assistance.": {
      hash: "23bbca4c71300543",
    },
    "from a previous session. Continue where you left off, or start over by posting": {
      hash: "414fdb23cbd5f38e",
    },
    here: {
      hash: "fcec91509759ad99",
    },
    or: {
      hash: "7175517a370b5cd2",
    },
    "so we can assist.": {
      hash: "da1f3c19871c3a58",
    },
    "the upcoming winter storm": {
      hash: "5e40f803e47d6624",
    },
    "the winter storm": {
      hash: "1ef1ab0d0f5450eb",
    },
    "these {{count}} shifts": {
      hash: "b59c75232481974b",
    },
    "this shift": {
      hash: "b0a7b3c03119094c",
    },
    "to re-enroll your account. Pending status means you are not able to accept further shifts, but any shifts that are already filled will not be affected. If you're not authorized to sign this agreement, please forward this link to the relevant person at your organization. For any questions, please contact":
      {
        hash: "b2eb2fd9a90f488b",
      },
    "{{count}} Shift": {
      hash: "968e3c7a50310a66",
    },
    "{{count}} Shifts": {
      hash: "8e36307961c6d5c1",
    },
    "{{count}} available professional": {
      hash: "1c88343383eec30e",
    },
    "{{count}} available professionals": {
      hash: "600dc26d055ac98a",
    },
    "{{count}} candidates are awaiting your review. Please review them now and choose to request an interview or decline.":
      {
        hash: "c6e9bec0b2a092db",
      },
    "{{count}} shift": {
      hash: "a93acb02cbaea116",
    },
    "{{count}} shifts": {
      hash: "cd72097a6f69799d",
    },
    "{{failed}} shift could not be removed": {
      hash: "1367a2d916565114",
    },
    "{{failed}} shifts could not be removed": {
      hash: "1e7a2f6e8859d410",
    },
    "{{filledShiftsCount}} of {{totalShifts}} filled": {
      hash: "b82274d4b5cf3655",
    },
    "{{postedShiftCount}} of {{totalPendingShifts}} posted": {
      hash: "bc17b7d2c6a26cbf",
    },
    "{{qualificationLabel}} shifts?": {
      hash: "6cca5d22536aef55",
    },
    "{{removed}} shift removed": {
      hash: "c1a2763f82ebe0b9",
    },
    "{{removed}} shifts removed": {
      hash: "627bfc3844c6d390",
    },
    "{{slotLabel}} end time": {
      hash: "ff7ebe47a75b69b6",
    },
    "{{slotLabel}} shifts, empty": {
      hash: "65b05e85db8eb9ce",
    },
    "{{slotLabel}} shifts, {{filledCount}} filled out of {{totalCount}}": {
      hash: "fdc923f7b593d952",
    },
    "{{slotLabel}} shifts, {{filledCount}} filled out of {{totalCount}}, time slot has passed": {
      hash: "2dc9bc64d8899540",
    },
    "{{slotLabel}} start time": {
      hash: "b50e079820bbe89d",
    },
  },
  settings: {
    About: {
      hash: "4efca0d10c5feb8e",
    },
    "Add Extended Break Rule": {
      hash: "bf8d19636791d7d7",
    },
    "Add any additional breaks for longer shift lengths here. When selected, workers will be required to take the set break length for the shift length defined below.":
      {
        hash: "c88a1f4319eaaf8d",
      },
    "Allow professionals to propose rates on shifts": {
      hash: "a0be4aaec8295265",
    },
    "Any qualification": {
      hash: "da50017b4af59e26",
    },
    "App version and update information.": {
      hash: "ec6dd417ce5e7977",
    },
    "Auto-verify shifts after clock-out (Grace Period)": {
      hash: "31ca56a9136579db",
    },
    "Auto-verify threshold in minutes": {
      hash: "c02747ac5f5c7273",
    },
    "Automatically decline expiring break payment requests": {
      hash: "aaefaa4c202b693c",
    },
    "Block professionals from booking excessive consecutive hours": {
      hash: "aba5efd1a814f972",
    },
    "Block professionals from booking excessive weekly hours": {
      hash: "10028063dd2dfd0d",
    },
    "Break length in minutes": {
      hash: "9d481643628c5d4e",
    },
    Build: {
      hash: "bdd254b65baac169",
    },
    "Calendar Display": {
      hash: "a9b847b2689edc15",
    },
    "Call instructions": {
      hash: "a307781c6d410504",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    Charting: {
      hash: "f4d573798f5b25fe",
    },
    "Charting Compliance": {
      hash: "6c5b2cad2f85979d",
    },
    "Charting Compliance Grace Period": {
      hash: "4ea6b01896b99aaa",
    },
    "Compliance & Documentation": {
      hash: "f46c7130506f2478",
    },
    "Configure clock-in restrictions, break policies, and attendance verification.": {
      hash: "362a5555c74569b3",
    },
    "Configure local translation preferences for redesigned admin pages.": {
      hash: "1f8b48da5e0d345f",
    },
    "Configure worker credentials for charting and timekeeping, and configure the onboarding view.":
      {
        hash: "de6f98ae0bbb9c6e",
      },
    "Configure worker type visibility and ordering on the calendar.": {
      hash: "c0aa98240e66b4c9",
    },
    "Control rate negotiation and billing integrations.": {
      hash: "29e2cad39d7468e7",
    },
    "Declination reason": {
      hash: "b1cfc10aede4c39f",
    },
    Disable: {
      hash: "b7e3e4aa4257b9a1",
    },
    "Disable Maple integration?": {
      hash: "774e9813ce70b676",
    },
    "Disabling the Maple integration will stop all shift syncing with Maple for this workplace. This may cause the integration to become out of sync.":
      {
        hash: "3251e2ac1ea2509c",
      },
    Edit: {
      hash: "464c4ffd019e1e96",
    },
    "Edit Start of Shift Orientation": {
      hash: "7e8e9084e6c5087a",
    },
    "Edit call instructions": {
      hash: "9bf39a1c52cfe90e",
    },
    "Edit declination reason": {
      hash: "9578186350a9aa2d",
    },
    "Edit paid rest period policy": {
      hash: "a06e6300e86256b9",
    },
    "Edit policy": {
      hash: "18f41a84465f6462",
    },
    Enable: {
      hash: "5342e09f2729fbc6",
    },
    "Enable Instant Book for previously approved professionals": {
      hash: "9c44b4cfe4f02691",
    },
    "Enable Maple integration?": {
      hash: "2f6ffdd61800cc85",
    },
    "Enable QR code sign out": {
      hash: "2de9bd54d2237316",
    },
    "Enable Request to Book": {
      hash: "851c9851d07cd16f",
    },
    "Enable auto-verify shifts after clock-out": {
      hash: "3770d69cbbc0b4b1",
    },
    "Enable translations": {
      hash: "b1f349369ee29a78",
    },
    "Enabling the Maple integration will sync shifts with Maple for this workplace.": {
      hash: "245e2e6200d75f82",
    },
    English: {
      hash: "ba118bf7fc9c1aed",
    },
    "Enter a default declination reason to use at the end of the review window": {
      hash: "ed7d194dfdf2d7d2",
    },
    "Enter device ID": {
      hash: "5a73db704d5aba8e",
    },
    "Enter {{fieldName}}...": {
      hash: "12f3883c328acb33",
    },
    "Error updating facility profile": {
      hash: "4e11fb106fc1beaf",
    },
    "For shifts that exceed {{shiftHours}} hours, required break is {{breakMinutes}} minutes": {
      hash: "2a9946d5fcbee4bc",
    },
    "Has active shifts in the next 2 weeks": {
      hash: "5ad1562de87b82a2",
    },
    Hidden: {
      hash: "7e6fefff0f0aeb6c",
    },
    "HostedTime device ID": {
      hash: "e891d5cd0ea25608",
    },
    "HostedTime integration device ID": {
      hash: "76eef37fa34912c2",
    },
    "If this is turned on, professionals can propose a new pay rate, giving your workplace a fast way to fill more shifts.":
      {
        hash: "2b9d1e8092595413",
      },
    "If this is turned on, professionals can propose a new pay rate, giving your workplace a fast way to fill more shifts. Learn more at the support center.":
      {
        hash: "e1fc7d1f6da04cae",
      },
    "Is this workplace integrated with Maple?": {
      hash: "990e61f759a1f123",
    },
    "Job Management": {
      hash: "04f96eeb9c8090d1",
    },
    Language: {
      hash: "a4fe65264ef7dbb3",
    },
    "Late-cancellation call instructions": {
      hash: "af40ec4cf6746601",
    },
    "Late-cancellation call notification": {
      hash: "2be38aafe50a4f66",
    },
    "Learn more": {
      hash: "1445799c033a2d17",
    },
    "Leave empty to apply orientation at the workplace level: only a single orientation is required for a professional for any qualification. Select qualifications to require orientation only for those, with each completed orientation counting toward the qualification it covered.":
      {
        hash: "f01334330fe346ac",
      },
    "Manage booking modes and shift hour limits.": {
      hash: "2763e3a812c08d7a",
    },
    "Manage job settings for child facilities.": {
      hash: "f0dfe26e63bc8617",
    },
    "Manage jobs for my child facilities": {
      hash: "1dcfa9963127e7d0",
    },
    "Mandatory break policy": {
      hash: "aee6b41152429015",
    },
    "Maximum consecutive hours": {
      hash: "900b85f3c4e41b75",
    },
    "Maximum weekly hours": {
      hash: "30dd117c4f6b1bf9",
    },
    "Move {{label}} down": {
      hash: "b1c733b78cb882ff",
    },
    "Move {{label}} up": {
      hash: "fe5d18d769b290af",
    },
    "No job management settings are available for this workplace.": {
      hash: "d2752a3342c348f8",
    },
    "No professional types configured for this workplace.": {
      hash: "160f3779e2189100",
    },
    "No rate and billing settings are available for this workplace.": {
      hash: "3eabdb54abdd1e4d",
    },
    None: {
      hash: "dc937b59892604f5",
    },
    "Number of hours before a shift starts to consider it 'starting soon' and highlight professionals who still need credentials.":
      {
        hash: "6ef0516afc1179be",
      },
    "Onboarding View": {
      hash: "e0350a790c9138d1",
    },
    "Only administrators can change these settings. Contact Clipboard support to request changes.":
      {
        hash: "ec37e0df8aea84f1",
      },
    "Orientation length": {
      hash: "d92c232bd70bea33",
    },
    "Orientation length must be a whole number between {{minimum}} and {{maximum}} minutes": {
      hash: "2f299751a552286f",
    },
    "Paid rest period policy": {
      hash: "17ce210985676544",
    },
    Platform: {
      hash: "c78ffe19571018fb",
    },
    Policy: {
      hash: "c611981fab983bc6",
    },
    "Prevent professionals from booking double shifts": {
      hash: "0e520b951ba12cc3",
    },
    "Prevent professionals from booking excessive weekly hours": {
      hash: "65602a19e4ee5fd9",
    },
    "Prevent professionals from clocking in early": {
      hash: "cfa3e1caf0b1b2d8",
    },
    "Provide optional paid rest periods": {
      hash: "6ce93b6727c1ec8a",
    },
    "Qualification-specific orientation": {
      hash: "e9d01a96cb9107e8",
    },
    "Rate & Billing": {
      hash: "21b66fba384beedc",
    },
    Reason: {
      hash: "f81ab834de5f8491",
    },
    "Remove break rule": {
      hash: "dfb40b548c292714",
    },
    "Require a badge during shifts": {
      hash: "4496feb166897bf2",
    },
    "Require mandatory break": {
      hash: "712ee289a8a1a83a",
    },
    "Restrict shift invites that would exceed 17 hours per day": {
      hash: "2b31bc9806c47521",
    },
    "Review and edit late-cancellation call instructions": {
      hash: "a6a219dce5737ccf",
    },
    "Review and edit the paid rest period policy": {
      hash: "c5fd090e8930f78e",
    },
    "Review and edit your facility's mandatory break policy": {
      hash: "3ff700627da62ace",
    },
    Save: {
      hash: "1509f561f2416598",
    },
    "Save Changes": {
      hash: "35322b5bb5a218a1",
    },
    Scheduling: {
      hash: "ed5c58303a981baa",
    },
    Select: {
      hash: "2a78025de6aae5e7",
    },
    "Select facilities": {
      hash: "516815728ebada54",
    },
    "Select the facilities that you want to manage jobs for.": {
      hash: "bafba7a74c5477f4",
    },
    Server: {
      hash: "aef7de28d52977f1",
    },
    "Set badge requirements, sign-out methods, and charting compliance.": {
      hash: "15b937dfd1192007",
    },
    "Set the maximum number of consecutive work hours allowed within a 24-hour period.": {
      hash: "37c36d3083a02a9d",
    },
    "Set the maximum number of work hours allowed per week (Sunday to Saturday).": {
      hash: "c587ea41a339ba29",
    },
    "Shift Starting Soon Threshold": {
      hash: "0c5c6608de487c25",
    },
    "Shift length in hours": {
      hash: "d020f667999d89b9",
    },
    "Shifts will be automatically verified for clocking out up to {{minutes}} {{unit}} over their scheduled shift end time. Only applied when shift extension is enabled for this workplace.":
      {
        hash: "f714dda64c6790b5",
      },
    "Show or hide professional types on the calendar. Use arrows to reorder.": {
      hash: "f91bbb0188572f4b",
    },
    Spanish: {
      hash: "3411059cb8e0660e",
    },
    "Spanish is the first supported translation language.": {
      hash: "d4db2907bd237cf0",
    },
    "Start of Shift Orientation": {
      hash: "cddc9d387f818111",
    },
    "Start of Shift Orientation configuration": {
      hash: "db7ee8ce4a71ce8b",
    },
    "The duration in hours a professional has to return and complete charting.": {
      hash: "a912692269072e1d",
    },
    "This workplace requires that all Independent Contractors using Clipboard wear a badge at all times during a shift.":
      {
        hash: "936e661e1282b74a",
      },
    "Time & Attendance": {
      hash: "a6677f62a5e6437c",
    },
    Timekeeping: {
      hash: "5306e22284383c9e",
    },
    "Toggle on to automatically verify shifts that clock out shortly after their scheduled end time. Only applied when shift extension is enabled for this workplace.":
      {
        hash: "a9c5f50f24ffd660",
      },
    "Translate redesigned admin pages while we evaluate the workflow.": {
      hash: "b337b6dc39b18486",
    },
    Translation: {
      hash: "6fbd766b1a71cc4d",
    },
    "Update ID": {
      hash: "42dac2c38c3d6b20",
    },
    "Updated settings": {
      hash: "ef593bf59fb4f1a1",
    },
    Version: {
      hash: "dd167905de0defca",
    },
    "Visible on calendar": {
      hash: "e7f458685df1a5c3",
    },
    "We will not charge you for clocked time before a shift's posted start time. Only applies to shifts worked after making this change. Please note that this may affect punctuality.":
      {
        hash: "c8cfe723d85dcdd3",
      },
    "When enabled, Clipboard will call the specified number per the instructions below if a professional cancels within 8 hours of the shift start time or no-shows.":
      {
        hash: "8ed3f28051797677",
      },
    "When enabled, a professional's first shift at this workplace starts earlier to include time for orientation.":
      {
        hash: "05d8e4ffb7e2376a",
      },
    "When enabled, expiring break payment requests will be declined. When disabled, they will be approved.":
      {
        hash: "f4022f08f2be1d48",
      },
    "When enabled, professionals can be recalled to complete charting. Professionals with incomplete charting will also be blocked from booking at your workplace.":
      {
        hash: "63019196ab3f47bc",
      },
    "When enabled, shows professionals who are missing credentials and have upcoming shifts, so credentials can be shared before their shift starts.":
      {
        hash: "fa432f02d32b7530",
      },
    "When enabled, staff at your workplace can scan a QR code to provide signatures and anonymous feedback at the end of shifts.":
      {
        hash: "fbb406ff9171f080",
      },
    "When enabled, the rest period policy will be visible to professionals in the app.": {
      hash: "cc3412a260c1fee8",
    },
    "When enabled, workplace users cannot send invites that would cause a professional to work more than 17 hours within a 24-hour period.":
      {
        hash: "b3aab3f479896b30",
      },
    "When enabled, workplace users will be able to share and manage charting credentials on behalf of workers.":
      {
        hash: "0ece9ff6f24f85f5",
      },
    "When enabled, workplace users will be able to share and manage timekeeping credentials on behalf of workers.":
      {
        hash: "cabfc417fcda90b4",
      },
    "Worker Credentials": {
      hash: "a4382a439a776868",
    },
    "You have unsaved break policy changes. Are you sure you want to leave?": {
      hash: "20a3669ea603e118",
    },
    hours: {
      hash: "404314b1f4bd8fa2",
    },
    min: {
      hash: "1f6fa6f69d185e60",
    },
    minute: {
      hash: "28cdd20eaf134a05",
    },
    minutes: {
      hash: "90e63d85fa1ab2c8",
    },
  },
} as const satisfies TranslationKeyMap;

/* eslint-enable max-lines -- generated translation artifact */
